import { Button, ConfirmationDialog, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

type CommitConfirmationDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  plotNames: string[];
  onConfirm: () => void;
  isSubmitting?: boolean;
};

/** Shared confirm step before committing draft plots, used for both an individual selection and a whole group. */
export const CommitConfirmationDialog = ({
  open,
  onOpenChange,
  plotNames,
  onConfirm,
  isSubmitting,
}: CommitConfirmationDialogProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      open={open}
      onOpenChange={onOpenChange}
      header={t('shared.uploadPlots.commit.confirm.header', { count: plotNames.length })}
      body={
        <Stack spacing={3} className='text-left'>
          <span>{t('shared.uploadPlots.commit.confirm.body')}</span>
          <ul className='typography-body2 max-h-40 list-inside list-disc space-y-1 overflow-y-auto rounded-xl border border-neutral-black-12 p-3 text-left'>
            {plotNames.map((name, i) => (
              <li key={`${name}-${i}`}>{name}</li>
            ))}
          </ul>
        </Stack>
      }
      CancelAction={
        <Button variant='outline' onClick={() => onOpenChange(false)}>
          {t('global.ui.buttons.cancel')}
        </Button>
      }
      PrimaryAction={
        <Button loading={isSubmitting} onClick={onConfirm}>
          {t('shared.uploadPlots.commit.confirm.action')}
        </Button>
      }
    />
  );
};
